import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { AppResource } from './app.resource';
import { environment } from 'src/environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppInsightsService } from './shared/services/app-insight.service';
import { WINDOW_PROVIDERS } from './shared/services/window.service';
import {
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalService
} from '@azure/msal-angular';
import { MSALInstanceFactory } from './msal-config';
import { MSALInterceptorConfigFactory } from './shared/interceptor/msal.interceptor';
import { AuthBearerInterceptor } from './shared/interceptor/bearer.interceptor';
import { MaintenanceInterceptor } from './shared/interceptor/maintenance.interceptor';
import { provideLottieOptions } from 'ngx-lottie';
import { FunnelTrackingService } from './shared/services/funnel-tracking.service';

export function initResource(resource: AppResource) {
  return () => resource.load(environment.brand);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(BrowserModule),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideAnimations(),
    AppResource,
    AppInsightsService,
    ...WINDOW_PROVIDERS,
    {
      provide: APP_INITIALIZER,
      useFactory: initResource,
      deps: [AppResource],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (tracker: FunnelTrackingService) => () => tracker.start(),
      deps: [FunnelTrackingService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MaintenanceInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthBearerInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalBroadcastService
  ]
};
